import React from 'react';
import { number, string } from 'prop-types';
import { Bag } from '@nike/nike-design-system-icons';
import { BagContainer, BagCountText } from './styles';

/**
 * Renders the bag icon with a count of items in the bag
 * @param {object} props
 * @param {number} props.count
 * @returns {React.ReactElement}
 */
export const BagWithCount = ({ className = '', count }) => {
  const bagCount = count >= 10 ? '9+' : count;
  return (
    <BagContainer className={className}>
      <Bag />
      <BagCountText>{count > 0 ? bagCount : null}</BagCountText>
    </BagContainer>
  );
};

BagWithCount.propTypes = {
  count: number,
  className: string,
};
